<template>
	<div class="flexCol alit">
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E8%AE%BE%E6%96%BD%E5%86%9C%E4%B8%9A/PhotoshopExtension_Image%20%281%29.png"
			alt="" />
		<!-- <img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E8%AE%BE%E6%96%BD%E5%86%9C%E4%B8%9A/%E7%94%98%E8%82%83%E5%BC%A0%E6%8E%966.png"
			alt="" style="width: 90%;margin-top: 20px;" /> -->
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">温室大棚的现存问题及发展契机</div>
		<img style="width: 80%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E7%94%B0/c2e2be32352bbed3eb817985ab7b2cd4.png"
			alt="" />
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">智慧大棚建设方案</div>
		<div class="title-desc">发展智能化，旨在帮助新农人全面创收</div>

		<div class="desc">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;以实现“温室大棚的全面现代化，新农人的全面创收”为宗旨，对温室大棚进行全面升级和改造，建设全面智能化、数据化的生产、管理和销售体系。为农业新型经营主体(企业、合作社、家庭农场、大棚大户)提供全方位的信息服务，实现生产管理的智能化和标准化，销售管理的品牌化。全面降低生产、管理的成本，提升产品产量和质量，让农事生产更轻松、收益更高。
		</div>
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E6%A3%9A/5.png" style="width: 60%;margin: 20px 0;" alt="" />

		<div class="title" style="margin-top: 30px;margin-bottom: 5px;">核心优势</div>
		<div class="title-desc">以工厂化思维保障设施农业降本增效</div>
		<img style="width: 63%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E8%AE%BE%E6%96%BD%E5%86%9C%E4%B8%9A/%E6%A0%B8%E5%BF%83%E4%BC%98%E5%8A%BF.png"
			alt="" />
			<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E6%A3%9A/2.png" style="width: 60%;" alt="" />
			
			<div class="title" style="margin-top: 40px;margin-bottom: 15px;">标准化软件产品优势</div>
			<div class="title-desc">网页版+手机APP，随时随地无优管理</div>
			
			<div class="flex alit">
				<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E6%A3%9A/3.png" style="width: 25vw;height: 60vh;" alt="" />
				<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E6%A3%9A/21.png" alt="" style="width: 50vw;height: 65vh;" />
			</div>
		
	</div>
</template>

<script>
</script>

<style scoped>
	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 70%;
		font-size: 22px;
	}

	img {
		width: 100%;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>